export function range(num, min, max) {
  return Math.min(Math.max(num, min), max);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@2.2.16@vant/es/utils/format/number.js
// module id = null
// module chunks = 